var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMarkCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4747_336546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14286 8C1.14286 4.2129 4.2129 1.14286 8 1.14286C11.7871 1.14286 14.8571 4.2129 14.8571 8C14.8571 11.7871 11.7871 14.8571 8 14.8571C4.2129 14.8571 1.14286 11.7871 1.14286 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM10.8152 6.78894C10.9914 6.59828 10.9796 6.30092 10.7889 6.12478C10.5983 5.94863 10.3009 5.9604 10.1248 6.15107L6.58251 9.98531L5.49135 8.7304C5.32102 8.53452 5.02416 8.5138 4.82828 8.68412C4.6324 8.85444 4.61168 9.15131 4.782 9.34719L5.90136 10.6345C5.98626 10.7328 6.09139 10.8089 6.20643 10.8603C6.32184 10.9119 6.44685 10.9386 6.57181 10.94C6.69477 10.9412 6.81788 10.9181 6.93269 10.8707C7.04756 10.8232 7.1535 10.7518 7.24067 10.6581L10.8152 6.78894Z",
    fill: "#00A600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4747_336546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkCircle);
export default __webpack_public_path__ + "static/media/checkMarkCircle.e68c80e9cbe92b8ba99503852f8e256d.svg";
export { ForwardRef as ReactComponent };